<po-page-list
  p-title="Modulo de Entrada NFs - Notas Pendentes"
  [p-actions]="pageActions"
  [p-filter]="filterSettings">

  <div style="display: flex; justify-content: flex-end; margin-bottom: 8px; gap: 8px">
    <po-button
      p-icon="an an-funnel-x"
      p-label="Limpar Filtros"
      [p-disabled]="!hasActiveFilters"
      (p-click)="clearAdvancedFilter()">
    </po-button>
    <po-button
      p-kind="primary"
      p-icon="an an-funnel"
      p-label="Filtros"
      (p-click)="advancedFilterAction()">
    </po-button>
  </div>

  <po-loading-overlay [hidden]="!isLoading"></po-loading-overlay>

  <po-table
    #notasTable
    [p-columns]="columns"
    [p-items]="notasFiltered"
    [p-selectable]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-height]="tableHeight"
    [p-loading]="loadingMore"
    [p-show-more-disabled]="!hasMore"
    (p-show-more)="carregarMais()">
  </po-table>

</po-page-list>

<po-page-slide
  #slideFilterAdvanced
  p-size="auto"
  p-title="Filtros Avançados">

  <form [formGroup]="filterForm">

    <div class="po-row">
      <po-input
        class="po-xl-3 po-lg-4 po-md-6 po-sm-12"
        formControlName="numero"
        name="numero"
        p-label="Nº Nota">
      </po-input>
      <po-input
        class="po-xl-3 po-lg-4 po-md-6 po-sm-12"
        formControlName="rps"
        name="rps"
        p-label="Nº RPS">
      </po-input>
      <po-input
        class="po-xl-6 po-lg-8 po-md-12 po-sm-12"
        formControlName="fornecedor"
        name="fornecedor"
        p-label="Fornecedor">
      </po-input>
      <po-select
        class="po-xl-12 po-lg-12 po-md-12 po-sm-12"
        formControlName="tomadorCnpj"
        name="tomadorCnpj"
        p-label="Tomador"
        p-placeholder="Todos"
        [p-options]="tomadorOptions">
      </po-select>
      <po-select
        *ngIf="canViewOcultos"
        class="po-xl-3 po-lg-12 po-md-6 po-sm-12"
        formControlName="oculto"
        name="oculto"
        p-label="Oculto"
        p-placeholder="Selecione"
        [p-options]="ocultoOptions">
      </po-select>
      <po-select
        class="po-xl-3 po-lg-6 po-md-6 po-sm-12"
        formControlName="tipo"
        name="tipo"
        p-label="Tipo"
        p-placeholder="Selecione"
        [p-options]="tipoOptions">
      </po-select>
    </div>

    <hr>

    <div class="po-row">
      <po-datepicker
        class="po-xl-3 po-lg-6 po-md-6 po-sm-12"
        formControlName="emissaoDe"
        name="emissaoDe"
        p-clean
        p-label="Data Emissão de">
      </po-datepicker>
      <po-datepicker
        class="po-xl-3 po-lg-6 po-md-6 po-sm-12"
        formControlName="emissaoAte"
        name="emissaoAte"
        p-clean
        p-label="até">
      </po-datepicker>
      <po-decimal
        class="po-xl-3 po-lg-6 po-md-6 po-sm-12"
        formControlName="totalDe"
        name="totalDe"
        p-label="Valor Total de">
      </po-decimal>
      <po-decimal
        class="po-xl-3 po-lg-6 po-md-6 po-sm-12"
        formControlName="totalAte"
        name="totalAte"
        p-label="até">
      </po-decimal>
    </div>

  </form>

  <div class="po-row" style="margin-top: 16px;">
    <div class="po-xl-12" style="display: flex; gap: 8px; justify-content: flex-end;">
      <po-button
        p-icon="an an-funnel-x"
        p-label="Limpar Filtros"
        [p-disabled]="!hasActiveFilters"
        (p-click)="clearAdvancedFilter()">
      </po-button>
      <po-button
        p-label="Cancelar"
        p-kind="secondary"
        p-danger="true"
        (p-click)="cancelAdvancedFilter()">
      </po-button>
      <po-button
        p-label="Confirmar"
        p-kind="primary"
        (p-click)="confirmAdvancedFilter()">
      </po-button>
    </div>
  </div>

</po-page-slide>
